import axios from 'axios';
import { baseURL } from './baseUrl';


const api = axios.create({
  baseURL: `${baseURL}/api`,
});

export const createContact = (formData) => {
    return api.post("/contacts", {
        data: formData,
    });
};